import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import type {
  ConnectionStatus,
  DeviceConnection,
} from "../../../api/deviceConnection";

// Remplace l'ancienne pastille, qui lisait `device.status` : ce champ vaut « active » à la
// création et n'est jamais modifié, la pastille était donc toujours verte.

export const connectionDotClass = (status?: ConnectionStatus): string =>
  status === "connected"
    ? "bg-secondary"
    : status === "disconnected"
      ? "bg-red-500"
      : "bg-grey-medium";

/** Connexion à distance impossible : box vue déconnectée. Inconnu = on laisse essayer. */
export const isRemoteBlocked = (connection?: DeviceConnection): boolean =>
  connection?.status === "disconnected";

export const connectionLabel = (
  t: TFunction,
  connection?: DeviceConnection
): string => {
  const label =
    connection?.status === "connected"
      ? t("device-connection-connected")
      : connection?.status === "disconnected"
        ? t("device-connection-disconnected")
        : t("device-connection-unknown");
  return connection?.status === "connected" && connection.connected_since
    ? `${label} · ${t("device-connection-since", {
        since: connection.connected_since,
      })}`
    : label;
};

export const ConnectionDot = ({
  connection,
  className = "h-3 w-3",
}: {
  connection?: DeviceConnection;
  className?: string;
}) => {
  const { t } = useTranslation();
  const label = connectionLabel(t, connection);
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={`inline-block shrink-0 rounded-full ${className} ${connectionDotClass(
        connection?.status
      )}`}
    />
  );
};
